// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"380":"5ec13862","453":"ecc12249","822":"c765db50","908":"83bb4e19"}[chunkId] + ".chunk.js";
};